import { appApiSlice } from 'src/api/app-ApiSlice';
import { TAG_FLOOR_ROOMS_AND_RELATED, TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS } from 'src/api/api-tags';

export const floorApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFloor: builder.query<string, number>({
      query: (floorId: number) => ({
        url: `v1/floor/${floorId}`,
        responseHandler: (response) => response.text(),
      }),
    }),
    deleteRoom: builder.mutation<{ message: string }, number>({
      query: (roomId: number) => ({
        url: 'v1/floor/room',
        method: 'DELETE',
        body: { room_id: roomId },
      }),
      invalidatesTags: [{ type: TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS }, { type: TAG_FLOOR_ROOMS_AND_RELATED }],
    }),
  }),
  overrideExisting: false
});

export const {
  useGetFloorQuery,
  useDeleteRoomMutation,
} = floorApiSlice;
